var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6949 35.5182H1.30607C0.756256 35.5182 0.310547 35.9659 0.310547 36.5181V38.2466C0.310547 38.7989 0.756256 39.2466 1.30607 39.2466H58.6949C59.2447 39.2466 59.6904 38.7989 59.6904 38.2466V36.5181C59.6904 35.9659 59.2447 35.5182 58.6949 35.5182Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32031 35.4285V4.06883C5.32031 2.29341 6.75265 0.852661 8.52224 0.852661H50.9234C52.6909 0.852661 54.1253 2.29137 54.1253 4.06883V35.5182",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.908 3.99121H8.22852V32.9428H50.908V3.99121Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.92f3f866.svg";
export { ForwardRef as ReactComponent };